// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-large-superElipse-2069371e","strokeWidth":"super-ellipse-skins-large-strokeWidth-f7dfa51a"};